import lodash from 'lodash';
import { linkValidation } from '@/src/constrains/DraggableModules/tools';
import { TabBarItem, TabBarSetting } from '@/src/types/common/SalesChannel';

/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-22 17:39:57
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-06 16:18:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/validation/index.ts
 */
export const validation = (tabBar: TabBarSetting, isPrimary) => {
  let errCode = [];
  if (isPrimary) {
    if (!tabBar.name) {
      errCode.push(999997);
    }
    if ((!tabBar.startTime || !tabBar.endTime) && !tabBar.isDefault) {
      errCode.push(999996);
    }
  }

  const errorIndexList = validateTabs(tabBar.tabs, isPrimary);
  if (errorIndexList.length !== 0) {
    errCode = [...errCode, ...errorIndexList];
  }
  return lodash.uniq(errCode);
};

export const validateTabs = (tabs: TabBarItem[], isPrimary) => {
  let errorIndexList = [];
  // tabs.forEach((t: TabBarItem) => {
  //   if (isPrimary) {
  //     const err: any = linkValidation({ data: t.link });
  //     const linkTypeError = err.linkTypeError || [];
  //     if (linkTypeError.length > 0) {
  //       errorIndexList.push(999995);
  //     }
  //   }
  //   if (!t.icon && !t.title) {
  //     errorIndexList.push(999995);
  //   }
  // });
  if (tabs.some((t: TabBarItem) => !t.icon && !t.title)) {
    errorIndexList.push(999995);
  }
  if (isPrimary) {
    tabs.map((t: TabBarItem) => {
      const err: any = linkValidation({ data: t.link });
      const linkTypeError = err.linkTypeError || [];
      errorIndexList = [...errorIndexList, ...linkTypeError];
    });
  }

  // const e = lodash.uniq(errorIndexList);
  // console.log('e', e);
  return errorIndexList;
};
